import { accountPaymentProcessors } from "@circle-react/helpers/urlHelpers/internalApi/accountPaymentProcessors";
import { useMutation } from "react-query";

import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";

import { UPGRADE_PATHS } from "../constants";
import { useUpgradePlanNavigate } from "../upgradePlanRouterHelpers";

interface CheckoutSessionParams {
  conversation_uuid?: string;
  coupon_id?: number;
  plan_id: number;
  source: string;
}

export const useAccountPaymentProcessorsApi = () => {
  const navigate = useUpgradePlanNavigate();

  const { mutate: createCheckoutSession } = useMutation({
    mutationFn: ({
      plan_id,
      coupon_id,
      source,
      conversation_uuid,
    }: CheckoutSessionParams) =>
      reactQueryPost(accountPaymentProcessors.checkoutSession.create(), {
        plan_id,
        coupon_id,
        source,
        conversation_uuid,
      }),
    onSuccess: (data: { url: string }) => {
      window.location.href = data.url;
    },
    onError: () => {
      void navigate({ to: UPGRADE_PATHS.ERROR });
    },
  });

  return {
    createCheckoutSession,
  };
};
